import { useState } from "react";
import { MessageSquareText, Loader2, SendHorizonal } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import MicButton from "@/components/ui/MicButton";
import { reviseReport } from "@/lib/reports";

export default function RevisionChat({ dossierId, sessionId, kind, onRevised, disabled }) {
    const [q, setQ] = useState("");
    const [busy, setBusy] = useState(false);
    const [log, setLog] = useState([]);

    async function send(text) {
        const instruction = (text || q).trim();
        if (!instruction || busy) return;
        setBusy(true); setQ("");
        try {
            const r = await reviseReport(dossierId, sessionId, kind, instruction);
            onRevised(r.content);
            setLog((l) => [{ instruction, at: new Date().toISOString() }, ...l].slice(0, 5));
            toast.success("Rapport révisé par l'IA");
        } catch (e) { toast.error("Révision impossible", { description: e.message }); }
        finally { setBusy(false); }
    }

    return (
        <div data-testid={`revision-chat-${kind}`} className="rounded-md border border-dashed border-border bg-muted/30 px-4 py-3 space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground flex items-center gap-1.5"><MessageSquareText className="h-3.5 w-3.5" /> Chat de révision IA — modifiez le rapport par instruction</p>
            <form onSubmit={(e) => { e.preventDefault(); send(); }} className="flex items-center gap-2">
                <Input data-testid="revision-input" value={q} onChange={(e) => setQ(e.target.value)} disabled={busy || disabled} placeholder="Ex : « Rends la conclusion plus ferme et ajoute le passif social dans le tableau »" className="h-10 bg-background" />
                <MicButton testId="revision-mic" disabled={busy || disabled} onText={(t) => send(t)} />
                <Button type="submit" data-testid="revision-send" disabled={busy || disabled || !q.trim()} className="h-10 rounded-full bg-primary hover:bg-primary/90 px-4">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <SendHorizonal className="h-4 w-4" />} {busy ? "Réécriture…" : "Appliquer"}</Button>
            </form>
            {log.length > 0 && <ul className="text-xs text-muted-foreground space-y-0.5">{log.map((l) => <li key={l.at} data-testid="revision-log-item">• {l.instruction}</li>)}</ul>}
        </div>
    );
}
